<!-- <h2>c<small style="color:DarkGreen; margin: 15%;">{{brandName}}</small></h2>  -->

 <app-choose-brand [displayBrandDialog] = "openBrandSelectionDialog" (chooseBrandEvent)="chooseBrand($event)"></app-choose-brand>

 <div class="grid">
    <div class="col-6">
        <app-brand-admin-header></app-brand-admin-header>
    </div>
    <div class="col-1">
        <button pButton type="button" label="Brand" icon="pi pi-sitemap" iconPos="left" (click)="onChooseBrandClick($event)"  
             class="p-button-raised p-button-rounded"  [disabled]="isDetailsShown" *ngIf="isBrandSelectionButtonShown">
         </button>
    </div>  
</div> 

<!--  S E L E C T I O N   C R I T E R I A  -->

<div class="col-6">

    <div class="div-criteria-two wal-criteria-row">

        <!-- <h2 style="width: 15em; color: darkblue; margin-left: 2em;">Enrollment Clickthrough Statistics</h2> -->


            <div class="wal-criteria-item">
                <label for="dateFrom" class="col-fixed label" style="width: 3em">From: </label>
                <p-datePicker id="dateFrom" [(ngModel)]="selectedDateFrom" dateFormat="yy-mm-dd" placeholder="Date From:" 
                    [defaultDate]="defaultDate" [showIcon]="true" class="margin-left">
                </p-datePicker>
            </div>

            <div class="wal-criteria-item">
                <label for="dateTo" class="col-fixed label" style="width: 3em">To: </label>
                <p-datePicker id="dateTo" [(ngModel)]="selectedDateTo" dateFormat="yy-mm-dd" placeholder="Date To:" 
                    [showIcon]="true" class="margin-left">
                </p-datePicker>
            </div>

            <div class="wal-criteria-item wal-criteria-actions">
                <p-button type="button" label="Search" 
                    styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="onSearchClick($event)">
                </p-button>
                <p-button type="button" label="Clear" 
                    styleClass="p-button-primary wal-primary p-button-raised p-button-rounded margin-left" (click)="onClearClick($event)">
                </p-button>
            </div> 
                
            <div class="wal-criteria-item wal-criteria-status">
                <div id="idSpinner" [hidden]="isSpinnerHidden">
                <div class="loader"></div>  
                </div>
            </div>

    </div>


</div>

    <!--  E N R O L M E N T S   G R I D  -->

<div class="col-7">    


        <p-tabs class="wal-tabs" [(value)]="tabIndex">

          <p-tablist>

            <p-tab [value]="'Bar Chart View'">
              <span class="tab-label">
                <i class="pi pi-chart-bar" aria-hidden="true"></i>
                <span class="ml-2">Bar Chart View</span>
              </span>
            </p-tab>

            <p-tab [value]="'Grid View'">
              <span class="tab-label">
                <i class="pi pi-table" aria-hidden="true"></i>
                <span class="ml-2">Grid View</span>
              </span>
            </p-tab>

          </p-tablist>  

          <p-tabpanels>

            <p-tabpanel [value]="'Bar Chart View'">

                <p-chart type="bar" [data]="enrollmentStatsChart" [options]="optionsEnrollments" width="1000" height="500" ></p-chart>
    
            </p-tabpanel>

            <p-tabpanel [value]="'Grid View'">

                <div class="col-12">
    
                    <p-table #dtt [columns]="enrollmentStatsCols" [value]="enrollmentStats" selectionMode="single" 
                        class="wal-table"
                        tableStyleClass="prime-table" [rowsPerPageOptions]="[10,15,25,50]" [showCurrentPageReport]="true"
                        sortMode="multiple" [paginator]="true" [rows]="15">
                        <ng-template pTemplate="caption">
                        Enrollment Counts by Source and Platform
                        </ng-template>
                        <ng-template pTemplate="header" let-columns>
                        <tr>
						@for (col of columns; track col.field) {
							<th [pSortableColumn]="col.field"
								[style.display]="col.display"
								[style.width]="col.width">
								{{ col.header }}
								<p-sortIcon [field]="col.field"></p-sortIcon>
							</th>
						}
                        </tr>
                        </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr [pSelectableRow]="rowData">
                                @for (col of columns; track col.field) {
                                    <td [style.width]="col.width" [style.display]="col.display">
                                        {{ rowData[col.field] }}
                                    </td>
                                }
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div style="text-align:left">
                                <p-button type="button" label="CSV Export" 
                                    styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="dtt.exportCSV()">
                                </p-button>
                            </div>
                        </ng-template>    
                    </p-table> 
                </div>

            </p-tabpanel>

          </p-tabpanels>        

        </p-tabs>



    <p-confirmDialog  class="lf-confirm-dialog" appendTo="body"></p-confirmDialog>

</div>

